import React from "react";

function generateRandomColor() {
  var colorCode = Math.floor(Math.random() * 16777215).toString(16);
  var color = "#" + colorCode;
  return color;
}

function NameLogo({ name }) {
  return (
    <div
      className=" font-bold w-7 h-7 rounded-[50%] flex items-center justify-center p-4"
      style={{ background: generateRandomColor() }}
    >
      {name[0]}
    </div>
  );
}

export default NameLogo;
